/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { jsx } from '@atlaskit/css';
import Suspense from '@atlaskit/react-ufo/suspense';

const LazyCreateWithRovoAnimatedLoadingGif = React.lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/create-with-rovo-loading-animated-gif" */ './main'
		),
);

/**
 * @todo move to @atlassian/rovo-platform-ui-components
 */
export const LazyAnimatedCreateWithRovoIcon: React.MemoExoticComponent<
	({
		alt,
		testId,
		width,
		height,
	}: {
		alt?: string;
		testId?: string;
		width?: string;
		height?: string;
	}) => JSX.Element
> = React.memo(
	({
		alt = '',
		testId = '',
		width = '',
		height = '',
	}: {
		alt?: string;
		testId?: string;
		width?: string;
		height?: string;
	}): JSX.Element => {
		return (
			<Suspense
				interactionName="rovo-conversation-assistant-create-with-rovo-animated-icon"
				fallback={null}
			>
				<LazyCreateWithRovoAnimatedLoadingGif
					alt={alt}
					testId={testId}
					width={width}
					height={height}
				/>
			</Suspense>
		);
	},
);
